<template>
  <div class="box full">
    <UnificadoFinder
      v-model="showFinder"
      @selected="
        e => {
          newUnificado = e;
          showFinder = false;
        }
      "
    />
    <div class="box-header">
      {{ $t("message.products_related.title") }}
    </div>
    <div class="box-content-block pt-4">
      <input
        type="text"
        class="regular bordered clear m-2"
        :placeholder="$t('message.products_related.unificado')"
        :value="unificado"
        disabled
      />
      <input
        type="text"
        class="regular bordered clear m-2"
        :placeholder="$t('message.products_related.unificado_related')"
        v-model="newUnificado"
        disabled
      />
      <button
        class="bg-green-success p-2 text-white rounded-md overflow-hidden"
        @click="createVariation"
        v-if="newUnificado !== ''"
      >
        {{ $t("message.products_related.add") }}
      </button>
      <button class="p-2 text-blue-700" @click="showFinder = true">
        {{ $t("message.products_related.search") }}
      </button>
    </div>
    <div class="box-content-block pt-4 items-grid">
      <ProductsVariationItem
        v-for="product in products"
        :key="product.nkrCode"
        :product="product"
        @deleteProduct="deleteProduct(product.unificado)"
      />
    </div>
  </div>
</template>
<script>
import {
  getProductsRelated,
  productRelatedDelete,
  productVariationInsert
} from "@/api/masterAdmin/ProductsBaseRelatedService.js";
import ProductsVariationItem from "./ProductsVariationItem.vue";
import UnificadoFinder from "./UnificadoFinder.vue";
export default {
  name: "ProductsVariationsManager",
  components: {
    ProductsVariationItem,
    UnificadoFinder
  },
  props: {
    unificado: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      products: [],
      showFinder: false,
      newUnificado: ""
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      getProductsRelated(this.unificado).then(res => {
        console.log(res);
        this.products = res;
      });
    },
    deleteProduct(unificado) {
      productRelatedDelete(unificado)
        .then(() => {
          this.products = this.products.filter(
            product => product.unificado !== unificado
          );
          this.$toast.open({
            message: `Relation deleted`,
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error deleting product`,
            type: "error",
            position: "top-right"
          });
        });
    },
    createVariation() {
      if (this.unificado === "") return;

      productVariationInsert(this.unificado, this.newUnificado).then(res => {
        if (res.status === "success") {
          this.newUnificado = "";
          this.loadProducts();
          this.$toast.open({
            message: `Relation added`,
            type: "success",
            position: "top-right"
          });
        } else {
          this.$toast.open({
            message: res.message,
            type: "error",
            position: "top-right"
          });
        }
      });
    }
  }
};
// <div class="box-content-block">
//       Products base relation here
//       <br />
//       /Products_base_relation/get_single_related_products/8978905402
//       <br />
//       <br />
//       /Products_base_relation/new_relation
//       <br />
//       {"relation":{"unificado":"8978905402", "unificado_related":"29405L1000"}}
//       <br />
//       <br />
//       /Products_base_relation/delete_product
//       <br />
//       {"unificado":"8978905402"}
//     </div>
</script>

<style lang="postcss" scoped>
.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 10px;
}
</style>
